import { combineReducers } from "redux";

import qr from "../features/admin/whatsapp/qr/qrSlice"
import template from "../features/admin/whatsapp/template/slice"
import reports from "../features/admin/whatsapp/reports/slice"
import Message from "../features/admin/whatsapp/message/slice"
import autoReply from "../features/admin/whatsapp/auto_reply/slice"
import welcomeMsg from "../features/admin/whatsapp/welcome_message/slice"
import support from "../features/admin/whatsapp/support/slice"
import group from "../features/admin/whatsapp/group/slice"


const whatsapp = combineReducers({
    qr: qr,
    template: template,
    reports: reports,
    Message: Message,
    autoReply: autoReply,
    welcomeMsg: welcomeMsg,
    support: support,
    group: group,
});

export default whatsapp;
